<script>
    import ContactForm from '../content/ContactForm.svelte';
</script>

<!-- svelte-ignore a11y-missing-content -->
<a id="contact" class="flex" href="#contact" />
<ContactForm />
